export const contentData = {
  spanish:{
    title:'Crear outsourcing',
    nodata:'Sin Registro',
    error:'Sin registro',
    button:'Guardar',
    cancelButton:'Cancelar',
    image_button:'Cambiar',
    form:{
      name:{
        label:'Nombre',
        placeholder:'Nombre',
      },
      specs:{
        label:'Especificaciones',
        placeholder:'Especificaciones'
      },
      responsible_id:{
        label:'Responsable',
        placeholder:'Responsable',
      },
      periodicity_id:{
        label:'Periodicidad',
        placeholder:'Periodicidad',
      },
      net_salary:{
        label:'Salario Neto a Depositar',
        placeholder:'Salario Neto a Depositar',
      },
    },
  },
}